import { useNavigate } from "react-router-dom";
// src/pages/ArbitragePage.jsx — v9.2 FIXED
//
// ПРИЧИНЫ КРАША (3 бага):
//
// BUG 1 (ГЛАВНЫЙ): <SystemHealthBlock health={health} /> внутри ArbitrageHero
//   health — это useState из ArbitragePage (родитель).
//   ArbitrageHero — дочерняя функция, health недоступен в её scope.
//   React бросал ReferenceError: health is not defined → чёрный экран.
//   ФИКС: убрать из ArbitrageHero, перенести в render ArbitragePage (шаг 7).
//
// BUG 2: <StepDivider label="System Stability" /> тоже внутри ArbitrageHero — убран.
//
// BUG 3: data={trendData} вместо data={buildCounterfactual(...)} — ghost line не работала.

import { useEffect, useState } from "react";
import { workerClient } from "../api/workerClient";

import FinanceChartV10    from "../components/dashboard/FinanceChartV10";
import SystemHealthBlock  from "../components/dashboard/SystemHealthBlock";
import CrisisHighlight    from "../components/dashboard/CrisisHighlight";
import RecoveryHighlight  from "../components/dashboard/RecoveryHighlight";
import { usePreventedLoss }    from "../api/hooks/usePreventedLoss";
import PreventedLossAnalytics  from "../components/dashboard/PreventedLossAnalytics";
import { mapRiskHistory }      from "../api/mappers/riskMapper";
import { mapActions }          from "../api/mappers/antilossMapper";
import { buildCounterfactual } from "../api/mappers/buildCounterfactual";

function fmtMoney(v) {
  return `€${Math.round(Number(v) || 0).toLocaleString("en-US")}`;
}

function parseTs(ts) {
  if (!ts) return null;
  const n = Number(ts);
  return n > 1e12 ? new Date(n) : new Date(n * 1000);
}

const StepDivider = ({ label, accent }) => (
  <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
    <div style={{ height: 1, flex: 1, background: accent ? "rgba(16,217,126,0.2)" : "var(--border-subtle)" }} />
    <span style={{
      fontFamily: "var(--font-mono)", fontSize: 9, fontWeight: 700,
      letterSpacing: "0.16em", textTransform: "uppercase",
      color: accent ? "var(--success)" : "var(--text-muted)", flexShrink: 0,
    }}>
      {label}
    </span>
    <div style={{ height: 1, flex: 1, background: accent ? "rgba(16,217,126,0.2)" : "var(--border-subtle)" }} />
  </div>
);

// ── [0] Protection Hero ────────────────────────────────
// FIX: SystemHealthBlock и StepDivider убраны — health не в scope этой функции
function ArbitrageHero({ total, actions, loading }) {
  if (loading) return <div className="skeleton" style={{ height: 100, borderRadius: "var(--radius)" }} />;

  const t = Math.round(total || 0);
  const first = Array.isArray(actions) && actions.length
    ? [...actions].sort((a, b) => Number(a.timestamp) - Number(b.timestamp))[0]
    : null;
  const ts = parseTs(first?.timestamp);
  const timeOnly = ts
    ? ts.toLocaleString("en-GB", { hour: "2-digit", minute: "2-digit" })
    : "—";

  return (
    <div style={{ display: "flex", flexDirection: "column", alignItems: "center", textAlign: "center", gap: 12, padding: "20px 0 8px" }}>
      <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 4 }}>
        <div style={{ fontFamily: "var(--font-mono)", fontSize: 9, letterSpacing: "0.2em", textTransform: "uppercase", color: "var(--text-muted)" }}>
          Prevented Loss
        </div>
        <div style={{
          fontFamily: "var(--font-mono)", fontSize: "clamp(40px, 7vw, 56px)",
          fontWeight: 700, lineHeight: 1, letterSpacing: "-0.04em", color: "var(--success)",
          textShadow: "0 0 56px rgba(16,217,126,0.4), 0 0 22px rgba(16,217,126,0.2)",
        }}>
          {t > 0 ? fmtMoney(t) : "€0"}
        </div>
        <div style={{ fontFamily: "var(--font-mono)", fontSize: 13, color: "var(--text-secondary)", opacity: 0.85 }}>
          System prevented revenue loss at peak
        </div>
      </div>

      {t > 0 && (
        <div style={{
          padding: "10px 18px", borderRadius: "var(--radius-lg)",
          background: "var(--danger-bg)", border: "1px solid var(--danger-border)",
          maxWidth: 400, width: "100%",
        }}>
          <div style={{ fontFamily: "var(--font-mono)", fontSize: 14, fontWeight: 700, color: "var(--danger)" }}>
            Without VIRAJ: −{fmtMoney(t)} projected
          </div>
          <div style={{ fontFamily: "var(--font-mono)", fontSize: 10, color: "var(--text-muted)", marginTop: 3 }}>
            Based on trend continuation without protection
          </div>
        </div>
      )}

      {first && t > 0 && (
        <div style={{ display: "flex", gap: 10, flexWrap: "wrap", justifyContent: "center" }}>
          <div style={{
            display: "flex", alignItems: "center", gap: 7, padding: "7px 12px",
            borderRadius: "var(--radius)", background: "var(--action-bg)", border: "1px solid var(--action-border)",
            fontFamily: "var(--font-mono)", fontSize: 12,
          }}>
            <span style={{ color: "var(--action)", fontWeight: 700 }}>⚡</span>
            <span style={{ color: "var(--text-secondary)" }}>
              ACTION TRIGGERED AT <span style={{ color: "var(--action)", fontWeight: 700 }}>{timeOnly}</span>
            </span>
          </div>
          <div style={{
            display: "flex", alignItems: "center", gap: 7, padding: "7px 12px",
            borderRadius: "var(--radius)", background: "var(--action-bg)", border: "1px solid var(--action-border)",
            fontFamily: "var(--font-mono)", fontSize: 12,
          }}>
            <span style={{ color: "var(--action)" }}>⏱</span>
            <span style={{ color: "var(--text-secondary)" }}>
              Engine reacted in <span style={{ color: "var(--action)", fontWeight: 700 }}>2m 14s</span>
            </span>
          </div>
        </div>
      )}
    </div>
  );
}

// ── [2] Engine Reaction ────────────────────────────────
function EngineReactionBlock({ actions }) {
  const first = Array.isArray(actions) && actions.length
    ? [...actions].sort((a, b) => Number(a.timestamp) - Number(b.timestamp))[0]
    : null;
  const ts = parseTs(first?.timestamp);
  const timeOnly = ts
    ? ts.toLocaleString("en-GB", { hour: "2-digit", minute: "2-digit" })
    : "—";

  return (
    <div style={{
      padding: "14px 18px", borderRadius: "var(--radius)",
      background: "var(--action-bg)", border: "1px solid var(--action-border)",
    }}>
      <div style={{
        fontFamily: "var(--font-mono)", fontSize: 9, letterSpacing: "0.12em",
        textTransform: "uppercase", color: "var(--action)", marginBottom: 10, fontWeight: 700,
      }}>
        ⚡ Engine Reaction
      </div>
      <div style={{ display: "flex", justifyContent: "space-between", flexWrap: "wrap", gap: 16 }}>
        <div>
          <div style={{ fontFamily: "var(--font-mono)", fontSize: 13, color: "var(--text-primary)", marginBottom: 5 }}>
            Engine reduced exposure automatically
          </div>
          <div style={{ fontFamily: "var(--font-mono)", fontSize: 11, color: "var(--text-muted)" }}>
            Risk normalized CRITICAL → LOW
          </div>
        </div>
        <div style={{ textAlign: "right" }}>
          <div style={{ fontFamily: "var(--font-mono)", fontSize: 9, color: "var(--text-muted)", textTransform: "uppercase", marginBottom: 3 }}>Reaction time</div>
          <div style={{ fontFamily: "var(--font-mono)", fontSize: 20, fontWeight: 700, color: "var(--action)" }}>2m 14s</div>
          <div style={{ fontFamily: "var(--font-mono)", fontSize: 10, color: "var(--text-muted)", marginTop: 2 }}>
            AT {timeOnly}
          </div>
        </div>
      </div>
    </div>
  );
}

// ── [5] Actions Timeline ───────────────────────────────
function ActionsTimeline({ actions, riskHistory }) {
  const events = [];

  const crisis = [...(riskHistory ?? [])]
    .filter(d => d.risk_status === "critical" || d.risk_status === "red")
    .sort((a, b) => (a.date ?? "").localeCompare(b.date ?? ""))[0];
  if (crisis) {
    const roi = Number(crisis.roi);
    const pct = (Math.abs(roi) < 10 ? roi * 100 : roi).toFixed(1);
    events.push({ date: crisis.date, icon: "⚡", text: `Revenue efficiency degraded: ${Number(pct) > 0 ? "+" : ""}${pct}%`, color: "var(--danger)" });
  }

  const HUMAN = {
    reduce_spend:    "Spend reduced",
    limit_budget:    "Budget cap enforced",
    pause_campaigns: "Campaigns paused",
    safe_mode:       "Safe mode activated",
    monitor:         "Monitoring enhanced",
  };

  const byType = {};
  [...(actions ?? [])].sort((a, b) => Number(a.timestamp) - Number(b.timestamp)).forEach(a => {
    const k = a.action_type ?? "engine_action";
    if (!byType[k]) byType[k] = { count: 0, totalSaved: 0, firstTs: a.timestamp };
    byType[k].count++;
    byType[k].totalSaved += Number(a.prevented_loss) || 0;
  });

  Object.entries(byType).slice(0, 4).forEach(([type, data]) => {
    const ts2 = parseTs(data.firstTs);
    const dateStr = ts2 ? ts2.toLocaleString("en-GB", { day: "2-digit", month: "short" }) : "—";
    const label = HUMAN[type] ?? "Engine action";
    const countStr = data.count > 1 ? ` (×${data.count})` : "";
    const detail = data.totalSaved > 0 ? ` · saved ${fmtMoney(Math.round(data.totalSaved))}` : "";
    events.push({ date: dateStr, icon: "🛡", text: `${label}${countStr}${detail}`, color: "var(--text-secondary)" });
  });

  const rec = [...(riskHistory ?? [])]
    .filter(d => d.risk_status === "low" || d.risk_status === "green")
    .sort((a, b) => (a.date ?? "").localeCompare(b.date ?? ""))[0];
  if (rec) {
    const roi = Number(rec.roi);
    const pct = (Math.abs(roi) < 10 ? roi * 100 : roi).toFixed(1);
    events.push({ date: rec.date, icon: "✓", text: `Recovery confirmed · ROI ${Number(pct) > 0 ? "+" : ""}${pct}%`, color: "var(--success)" });
  }

  if (!events.length) return null;

  return (
    <div style={{ padding: "14px 18px", borderRadius: "var(--radius)", background: "var(--bg-card)", border: "1px solid var(--border-subtle)" }}>
      <div style={{ fontFamily: "var(--font-mono)", fontSize: 9, letterSpacing: "0.14em", textTransform: "uppercase", color: "var(--text-muted)", marginBottom: 14 }}>
        Actions Timeline
      </div>
      {events.map((e, i) => (
        <div key={i} style={{ display: "flex", alignItems: "flex-start", gap: 12, marginBottom: i < events.length - 1 ? 8 : 0 }}>
          <div style={{ display: "flex", flexDirection: "column", alignItems: "center", flexShrink: 0 }}>
            <span style={{ fontSize: 14, lineHeight: 1.4 }}>{e.icon}</span>
            {i < events.length - 1 && (
              <div style={{ width: 1, height: 16, background: "var(--border-subtle)", margin: "2px 0" }} />
            )}
          </div>
          <div>
            <div style={{ fontFamily: "var(--font-mono)", fontSize: 10, color: "var(--text-muted)", marginBottom: 2 }}>{e.date}</div>
            <div style={{ fontFamily: "var(--font-mono)", fontSize: 13, color: e.color }}>{e.text}</div>
          </div>
        </div>
      ))}
    </div>
  );
}

// ── [6] Final Result ───────────────────────────────────
function FinalResultCTA({ total }) {
  const t = Math.round(total || 0);
  return (
    <div style={{
      padding: "32px 28px", borderRadius: "var(--radius)",
      background: "var(--success-bg)", border: "1px solid var(--success-border)",
      textAlign: "center", display: "flex", flexDirection: "column", alignItems: "center", gap: 12,
    }}>
      <div style={{ fontFamily: "var(--font-mono)", fontSize: 9, letterSpacing: "0.2em", textTransform: "uppercase", color: "var(--success)" }}>
        Final Result
      </div>
      <div style={{
        fontFamily: "var(--font-mono)", fontSize: "clamp(28px, 4vw, 40px)",
        fontWeight: 700, lineHeight: 1, color: "var(--success)",
      }}>
        {t > 0 ? fmtMoney(t) : "€0"} saved
      </div>
      <div style={{ display: "flex", flexDirection: "column", gap: 5, marginTop: 4 }}>
        {[
          "Zero manual intervention",
          "System detected crisis in 2m 14s",
          "Traffic operations protected 24/7",
          "Automated analysis",
        ].map((txt, i) => (
          <div key={i} style={{ fontFamily: "var(--font-mono)", fontSize: 13, color: "var(--text-secondary)" }}>
            <span style={{ color: "var(--success)", marginRight: 8 }}>✓</span>{txt}
          </div>
        ))}
      </div>
      <a
        href="https://gumroad.com/l/viraj"
        target="_blank"
        rel="noopener noreferrer"
        style={{
          marginTop: 12, display: "inline-flex", alignItems: "center",
          background: "linear-gradient(135deg, #1ddf7a 0%, #6ee7b7 100%)",
          color: "#000", fontFamily: "var(--font-mono)", fontSize: 15, fontWeight: 800,
          letterSpacing: "0.08em", textTransform: "uppercase",
          padding: "14px 36px", borderRadius: 999,
          textDecoration: "none",
          boxShadow: "0 10px 36px rgba(16,217,126,0.45)",
        }}
      >
        BUY VIRAJ — €49
      </a>
    </div>
  );
}

// ── MAIN ──────────────────────────────────────────────
export default function ArbitragePage() {
  const navigate = useNavigate();
  const lossHook = usePreventedLoss();

  const [riskHistory, setRiskHistory] = useState([]);
  const [loss,        setLoss]        = useState(null);
  const [actions,     setActions]     = useState([]);
  const [trendData,   setTrendData]   = useState([]);
  const [loading,     setLoading]     = useState(true);
  const [health,      setHealth]      = useState(null);

  useEffect(() => {
    Promise.all([
      workerClient("/api/risk/history"),
      workerClient("/api/antiloss/prevented"),
      workerClient("/api/antiloss/actions"),
      workerClient("/api/finance/trends"),
      workerClient("/api/system/health"),
    ]).then(([histRes, lossRes, actRes, trends, healthRes]) => {
      if (healthRes) setHealth(healthRes);
      const hist = histRes?.items ?? [];
      if (Array.isArray(hist))          setRiskHistory(mapRiskHistory(hist));
      if (lossRes)                      setLoss(lossRes);
      if (Array.isArray(actRes?.items)) setActions(mapActions(actRes.items));
      if (Array.isArray(trends?.trend)) setTrendData(trends.trend);
    }).catch(() => {}).finally(() => setLoading(false));
  }, []);

  const heroTotal = lossHook.total30dRaw ?? Number(loss?.prevented_total) ?? 0;
  const total     = Number(loss?.prevented_total) || 0;

  // FIX 3: buildCounterfactual применён
  const chartData = buildCounterfactual(trendData, riskHistory, actions);

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
      {/* Return to Analyze */}
      <div data-no-print style={{ display: "flex", alignItems: "center", marginBottom: 4 }}>
        <button
          onClick={() => navigate("/analyze")}
          style={{
            fontFamily: "var(--font-mono)", fontSize: 10, cursor: "pointer",
            padding: "4px 10px", borderRadius: "var(--radius-sm)",
            background: "transparent", border: "1px solid var(--border-subtle)",
            color: "var(--text-muted)", display: "inline-flex", alignItems: "center", gap: 5,
          }}
        >
          ← Analyze
        </button>
      </div>

      {/* Header */}
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", paddingBottom: 10, borderBottom: "1px solid var(--border-subtle)" }}>
        <div>
          <div style={{ fontFamily: "var(--font-mono)", fontSize: 11, fontWeight: 700, letterSpacing: "0.08em", textTransform: "uppercase", color: "var(--text-primary)", marginBottom: 2 }}>
            Budget Protection Showcase
          </div>
          <div style={{ fontFamily: "var(--font-mono)", fontSize: 9, color: "var(--text-muted)" }}>
            Campaign Control Mode · one case · one result
          </div>
        </div>
        <div style={{ display: "inline-flex", alignItems: "center", gap: 6, padding: "4px 10px", borderRadius: "var(--radius)", background: "var(--accent-faint)", border: "1px solid var(--border-accent)", fontFamily: "var(--font-mono)", fontSize: 9, fontWeight: 700, letterSpacing: "0.12em", color: "var(--accent-primary)", textTransform: "uppercase" }}>
          <span style={{ width: 5, height: 5, borderRadius: "50%", background: "var(--accent-primary)", boxShadow: "0 0 6px var(--accent-primary)" }} />
          Campaign Control Mode
        </div>
      </div>

      {/* [0] HERO — FIX 1: без SystemHealthBlock */}
      <ArbitrageHero total={heroTotal} actions={actions} loading={loading} />

      {/* [1] CRISIS */}
      <StepDivider label="Crisis Detected" />
      <CrisisHighlight riskHistory={riskHistory} loading={loading} />

      {/* [2] ENGINE REACTION */}
      <StepDivider label="Engine Reaction" />
      <EngineReactionBlock actions={actions} />

      {/* [3] RECOVERY */}
      <StepDivider label="Recovery" />
      <RecoveryHighlight riskHistory={riskHistory} loading={loading} />

      {/* [4] FINANCIAL STORY — FIX 3: chartData = buildCounterfactual(...) */}
      <StepDivider label="Financial Story" />
      <FinanceChartV10 data={chartData} height={180} riskHistory={riskHistory} />

      {/* [5] TIMELINE */}
      <StepDivider label="Actions Timeline" />
      <ActionsTimeline actions={actions} riskHistory={riskHistory} />

      {/* A4: Prevented Loss Analytics — top incidents */}
      <StepDivider label="Protection Analysis" />
      <PreventedLossAnalytics actions={actions} loading={loading} />

      {/* [6] FINAL */}
      <StepDivider label="★ Final Result" accent />
      <FinalResultCTA total={total} />

      {/* [7] SYSTEM HEALTH — FIX 1: health из ArbitragePage scope */}
      <StepDivider label="System Stability" />
      <SystemHealthBlock health={health} />

    </div>
  );
}


